<div class="kpi-form">
  <h1>{{ title() }}</h1>

  @if (loading()) {
    <stena-skeleton-loader type="text" [rows]="3" />
  } @else {
    <div class="pickers">
      <app-context-picker
        [costCenters]="costCenters()"
        [months]="monthOptions()"
        [initialCostCenterId]="selectedCostCenterId()"
        [initialMonthId]="selectedMonthId()"
        (costCenterIdChange)="selectedCostCenterId.set($event)"
        (monthIdChange)="selectedMonthId.set($event)"
      />
      <div [formGroup]="pageIdForm">
        @if (loadingPages()) {
          <stena-skeleton-loader type="text" [rows]="1" />
        } @else {
          <stena-select
            class="dense-3"
            label="KPI area"
            formControlName="pageId"
            [options]="pageOptions()"
          />
        }
      </div>
    </div>

    @if (form(); as f) {
      <section class="form-body">
        <h2>{{ f.pageName }}</h2>
        @if (hasReadOnlyFields()) {
          <p class="readonly-legend">
            <span class="readonly-swatch">Disabled field</span>
            = value is imported and read-only, or otherwise not applicable.
          </p>
        }
        <div class="section-cards">
          @for (group of groupedRows(); track $index) {
            <mat-card class="section-card">
              @if (group.label) {
                <mat-card-header>
                  <mat-card-title>{{ group.label }}</mat-card-title>
                </mat-card-header>
              }
              <mat-card-content>
                <div class="rows">
                  @for (row of group.fields; track row.kpiBaseId) {
                    <div class="row-field" [class.readonly]="row.readOnly">
                      <label
                        class="row-label"
                        [attr.for]="'kpi-' + row.kpiBaseId"
                        >{{ row.name }}</label
                      >
                      <div class="row-input">
                        <input
                          [id]="'kpi-' + row.kpiBaseId"
                          type="number"
                          step="0.001"
                          [readonly]="row.readOnly"
                          [(ngModel)]="row.value"
                        />
                        @if (row.unit) {
                          <span class="row-unit">{{ row.unit }}</span>
                        }
                      </div>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
        <stena-button
          type="raised"
          color="primary"
          text="Save"
          [disabled]="saving()"
          (buttonClick)="onSave()"
        />
      </section>
    } @else if (canShowForm()) {
      <stena-skeleton-loader type="text" [rows]="2" />
    } @else {
      <p class="hint">
        Select cost center, KPI area, and
        {{ mode() === 'budget' ? 'fiscal year' : 'month' }} to load the form.
      </p>
    }
  }
</div>
